import service from '@/utils/request.js'
export function repositoryList(data) {
	return service.request({
		method: 'post',
		url: '/resource/selectAll',
		data
	});
}
export function getMenu() {
	return service.request({
		method: 'get',
		url: `/login/index.do`,
	});
}

export function listTrain(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/presstraininfo/list`,
		params
	});
}

export function treainDetail(id) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/presstraininfo/info/${id}`,
	});
}

export function getInfo() {
	return service.request({
		method: 'get',
		url: `/teacher/business/schooluserinfo/info`,
	});
}

export function getCourse(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/teacherselectbookinfo/getCourseList`,
		params
	});
}

export function getBookInfo(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/teacherselectbookinfo/bookInfo`,
		params
	});
}

export function getBanList(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/teacherselectbookinfo/getClassList`,
		params
	});
}

export function hasSemester() {
	return service.request({
		method: 'post',
		url: `/teacher/controller/teacherselectbookinfo/hasSemester`,
	});
}


export function bookSave(data) {
	return service.request({
		method: 'post',
		url: `/teacher/controller/teacherselectbookinfo/save`,
		data
	});
}

export function bookEdit(data) {
	return service.request({
		method: 'post',
		url: `/teacher/controller/teacherselectbookinfo/update`,
		data
	});
}


export function chatSave(data) {
	return service.request({
		method: 'post',
		url: `/teacher/controller/teacherreportmessage/save`,
		data
	});
}

export function huiGaoList(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/teacherreportmessage/list`,
		params
	});
}

export function pressList(params) {
	return service.request({
		method: 'get',
		url: `/teacher/controller/teacherreportmessage/messageTeacherList`,
		params
	});
}




